module.exports = __webpack_public_path__ + "static/img/cab-IRs.32ca6b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/cab-IRs.png
// module id = g5OR
// module chunks = 12